import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const SuperAdminBanner: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SuperAdminBanner" */ '../src/SuperAdminBanner.tsx'
			)
		).SuperAdminBanner,
});
